// extracted by mini-css-extract-plugin
export var baseLayer = "mapComponent-module--base-layer--lb6jv";
export var map = "mapComponent-module--map--uVWjJ";
export var mapArea = "mapComponent-module--map-area--i5PuV";
export var mapKey = "mapComponent-module--map-key--Fh0Rq";
export var mapKeyList = "mapComponent-module--map-key-list--VegDo";
export var mapKeyTitle = "mapComponent-module--map-key-title--4MWKx";
export var mobileMapKeyTitle = "mapComponent-module--mobile-map-key-title--iTrCB";